import * as Yup from 'yup';
import { cpfValidator } from '../../utils/CpfValidator';

export const NewBankAccountValidation = Yup.object({
  cpfTitularConta: Yup.string()
    .test('cpf-valid', 'Verifique se o CPF está correto, com 11 dígitos', function (value) {
      return cpfValidator(value || '');
    }).required('Insira um CPF válido e correto'),
});